var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "roleTemplateDetails" } },
    [
      _c(
        "div",
        { staticClass: "section-content" },
        [
          _vm.selected
            ? [
                _c("div", { staticClass: "vo-card" }, [
                  _c("div", { staticClass: "vo-header" }, [
                    _vm._v("\n          Role Template Details\n        ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "vo-content" }, [
                    _c("div", { staticClass: "vo-s-list" }, [
                      _c("div", { staticClass: "name" }, [_vm._v("Title")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.selected.title))
                      ])
                    ]),
                    _vm._v(" "),
                    !_vm.selected.isCustom
                      ? _c("div", { staticClass: "vo-s-list" }, [
                          _c("div", { staticClass: "name" }, [
                            _vm._v("Base Role")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "This is a base role and cannot be modified."
                            )
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.selected.isCustom
                    ? _c(
                        "div",
                        { staticClass: "vo-footer" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "vo-button",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  _vm.routeAddQueries({
                                    dialog: "role-template-manage",
                                    dialogAction: "edit"
                                  })
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("mdi-pencil")]),
                              _vm._v(" "),
                              _c("span", [_vm._v("Edit")])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "vo-button red",
                              attrs: { flat: "" },
                              on: { click: _vm.deleteRoleTemplateDialog }
                            },
                            [
                              _c("v-icon", [_vm._v("mdi-delete")]),
                              _vm._v(" "),
                              _c("span", [_vm._v("Delete")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            : [
                _c("vo-empty-state", {
                  attrs: { text: "SELECT A ROLE TEMPLATE" }
                })
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("vo-details-header")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a49acbdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a49acbdc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RoleTemplateDetails.vue
// module id = 560
// module chunks = 4